/* eslint-env browser */
import {registerPlugin} from '@webex/webex-core';

import Meetings from './meetings';
import config from './config';
import {
  LocusRetryStatusInterceptor,
  LocusRouteTokenInterceptor,
  DataChannelAuthTokenInterceptor,
} from './interceptors';
import CaptchaError from './common/errors/captcha-error';
import IntentToJoinError from './common/errors/intent-to-join';
import PasswordError from './common/errors/password-error';
import PermissionError from './common/errors/permission';
import JoinWebinarError from './common/errors/join-webinar-error';
import {
  ReclaimHostEmptyWrongKeyError,
  ReclaimHostIsHostAlreadyError,
  ReclaimHostNotAllowedError,
  ReclaimHostNotSupportedError,
} from './common/errors/reclaim-host-role-errors';
import Meeting from './meeting';
import MeetingInfoUtil from './meeting-info/utilv2';
import JoinMeetingError from './common/errors/join-meeting';
import {SdpResponseTimeoutError} from './common/errors/webex-errors';

registerPlugin('meetings', Meetings, {
  config,
  interceptors: {
    LocusRetryStatusInterceptor: LocusRetryStatusInterceptor.create,
    LocusRouteTokenInterceptor: LocusRouteTokenInterceptor.create,
    DataChannelAuthTokenInterceptor: DataChannelAuthTokenInterceptor.create,
  },
});

export {
  LocalStream,
  LocalDisplayStream,
  LocalSystemAudioStream,
  LocalStreamEventNames,
  StreamEventNames,
  RemoteStreamEventNames,
  type ServerMuteReason,
  LocalMicrophoneStreamEventNames,
  LocalCameraStreamEventNames,
  LocalMicrophoneStream,
  LocalCameraStream,
  createMicrophoneStream,
  createCameraStream,
  createCameraAndMicrophoneStreams,
  createDisplayStream,
  createDisplayStreamWithAudio,
  createDisplayMedia,
  FacingMode,
  DisplaySurface,
  PresetCameraConstraints,
  type VideoContentHint,
  type StreamState,
} from '@webex/media-helpers';

export default Meetings;

export * as CONSTANTS from './constants';
export * as REACTIONS from './reactions/reactions';
export * as sdkAnnotationTypes from './annotation/annotation.types';
export * as MeetingInfoV2 from './meeting-info/meeting-info-v2';
export {type Reaction} from './reactions/reactions.type';
export {SitePreferenceSelectOption} from './meetings/meetings.types';
export type {
  FetchSitePreferencesMeViaSiteOptions,
  SitePreferencesResponse,
} from './meetings/meetings.types';
export type {Interpreter, InterpreterUsingResource} from './interpretation/interpretation.types';

export {
  CaptchaError,
  IntentToJoinError,
  JoinMeetingError,
  PasswordError,
  PermissionError,
  ReclaimHostIsHostAlreadyError,
  ReclaimHostNotAllowedError,
  ReclaimHostNotSupportedError,
  ReclaimHostEmptyWrongKeyError,
  Meeting,
  MeetingInfoUtil,
  JoinWebinarError,
  SdpResponseTimeoutError,
};

export {RemoteMedia} from './multistream/remoteMedia';

export {default as TriggerProxy} from './common/events/trigger-proxy';

export {getAIEnablementApprover} from './aiEnableRequest/utils';
